"use client";
import algoliasearch from "algoliasearch";
import { useEffect, useState } from "react";
import Link from "next/link"; // Import Link
import { useRouter } from "next/navigation"; // Import useRouter
import classes from "./Landing.module.css";
import Listing from "@/components/UI/Carousels/Listing";

const ProductGrid = ({ collectionId }) => {
  const router = useRouter(); // Define router here

  const collection = collectionId;

  const client =
    process.env.NEXT_PUBLIC_OG_DB === "true"
      ? algoliasearch(
          process.env.NEXT_PUBLIC_ALGOLIA_APPID,
          process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
        )
      : algoliasearch(
          process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_APPID,
          process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_API_KEY
        );

  const [sameBrand, setSameBrand] = useState([]);

  const getListingsHandler = async (brand) => {
    const index = client.initIndex(
      process.env.NEXT_PUBLIC_OG_DB === "false"
        ? "kashew_listings"
        : `kashew_listings_branded_deals`
    );
    await index
      .search(brand, {
        hitsPerPage: 9,
        clickAnalytics: true,
        page: 0,
      })
      .then(async (res) => {
        setSameBrand(res.hits);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (collection) {
      getListingsHandler(collection.replace(/-/g, " "));
    }
  }, [collection]);

  return (
    <>
      <ul className={classes.productGrid}>
        {sameBrand &&
          sameBrand.length > 0 &&
          sameBrand.slice(0, 8).map((item, idx) => (
            <li className={classes.listing} key={idx}>
              <Listing listing={item} />
            </li>
          ))}
      </ul>
      {sameBrand.length > 8 && (
        <Link href={`/brand/${collectionId}`} className={classes.link}>
          <button className={classes.button}>View all products</button>
        </Link>
      )}
    </>
  );
};

export default ProductGrid;
